import { http } from "@/lib/api";

const q = (o = {}) => {
  const out = {};

  Object.entries(o).forEach(([k, v]) => {
    if (
      v !== undefined &&
      v !== null &&
      v !== "" &&
      v !== "All"
    ) {
      out[k] = v;
    }
  });

  return out;
};

const HRMS_BASE = "/api/hrms";

export const hrmsApi = {
  // --------------------------------------------------
  // General
  // --------------------------------------------------

  lookups: async () =>
    (await http.get(`${HRMS_BASE}/lookups`)).data,

  settings: async () =>
    (await http.get(`${HRMS_BASE}/settings`)).data,

  saveSettings: async (payload) =>
    (
      await http.post(
        `${HRMS_BASE}/settings`,
        payload
      )
    ).data,

  dashboard: async () =>
    (await http.get(`${HRMS_BASE}/dashboard`)).data,

  seedDemo: async () =>
    (
      await http.post(
        `${HRMS_BASE}/seed/demo`
      )
    ).data,

  // --------------------------------------------------
  // Employees
  // --------------------------------------------------

  listEmployees: async (opts = {}) =>
    (
      await http.get(
        `${HRMS_BASE}/employees`,
        {
          params: q(opts),
        }
      )
    ).data,

  getEmployee: async (id) =>
    (
      await http.get(
        `${HRMS_BASE}/employees/${encodeURIComponent(id)}`
      )
    ).data,

  createEmployee: async (payload) =>
    (
      await http.post(
        `${HRMS_BASE}/employees`,
        payload
      )
    ).data,

  updateEmployee: async (id, patch) =>
    (
      await http.patch(
        `${HRMS_BASE}/employees/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  deleteEmployee: async (id) =>
    (
      await http.delete(
        `${HRMS_BASE}/employees/${encodeURIComponent(id)}`
      )
    ).data,

  addDocument: async (id, payload) =>
    (
      await http.post(
        `${HRMS_BASE}/employees/${encodeURIComponent(id)}/documents`,
        payload
      )
    ).data,

  deleteDocument: async (id, docId) =>
    (
      await http.delete(
        `${HRMS_BASE}/employees/${encodeURIComponent(id)}/documents/${encodeURIComponent(docId)}`
      )
    ).data,

  // --------------------------------------------------
  // Attendance
  // --------------------------------------------------

  listAttendance: async (opts = {}) =>
    (
      await http.get(
        `${HRMS_BASE}/attendance`,
        {
          params: q(opts),
        }
      )
    ).data,

  saveAttendance: async (payload) =>
    (
      await http.post(
        `${HRMS_BASE}/attendance`,
        payload
      )
    ).data,

  bulkAttendance: async (entries) =>
    (
      await http.post(
        `${HRMS_BASE}/attendance/bulk`,
        {
          entries,
        }
      )
    ).data,

  deleteAttendance: async (id) =>
    (
      await http.delete(
        `${HRMS_BASE}/attendance/${encodeURIComponent(id)}`
      )
    ).data,

  register: async (month) =>
    (
      await http.get(
        `${HRMS_BASE}/attendance/register/${encodeURIComponent(month)}`
      )
    ).data,

  // --------------------------------------------------
  // Leaves
  // --------------------------------------------------

  listLeaves: async (opts = {}) =>
    (
      await http.get(
        `${HRMS_BASE}/leaves`,
        {
          params: q(opts),
        }
      )
    ).data,

  applyLeave: async (payload) =>
    (
      await http.post(
        `${HRMS_BASE}/leaves`,
        payload
      )
    ).data,

  decideLeave: async (
    id,
    status,
    approver = "HR"
  ) =>
    (
      await http.patch(
        `${HRMS_BASE}/leaves/${encodeURIComponent(id)}`,
        {
          status,
          approver,
        }
      )
    ).data,

  balance: async (empId, year) =>
    (
      await http.get(
        `${HRMS_BASE}/leaves/balance/${encodeURIComponent(empId)}`,
        {
          params: q({ year }),
        }
      )
    ).data,

  // --------------------------------------------------
  // Payroll
  // --------------------------------------------------

  listPayroll: async (opts = {}) =>
    (
      await http.get(
        `${HRMS_BASE}/payroll`,
        {
          params: q(opts),
        }
      )
    ).data,

  generatePayroll: async (payload) =>
    (
      await http.post(
        `${HRMS_BASE}/payroll/generate`,
        payload
      )
    ).data,

  paySummary: async (month) =>
    (
      await http.get(
        `${HRMS_BASE}/payroll/summary/${encodeURIComponent(month)}`
      )
    ).data,

  deleteMonthPayroll: async (month) =>
    (
      await http.delete(
        `${HRMS_BASE}/payroll/${encodeURIComponent(month)}`
      )
    ).data,

  // --------------------------------------------------
  // Payroll Import
  // --------------------------------------------------

  payrollImportPreview: async (
    file,
    month
  ) => {
    const fd = new FormData();

    fd.append("file", file);
    fd.append("month", month);

    return (
      await http.post(
        `${HRMS_BASE}/payroll/import/preview`,
        fd,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      )
    ).data;
  },

  payrollImportCommit: async (payload) =>
    (
      await http.post(
        `${HRMS_BASE}/payroll/import/commit`,
        payload
      )
    ).data,

  // --------------------------------------------------
  // Report Export URLs
  // --------------------------------------------------

  urlEmployees: () =>
    `${http.defaults.baseURL}${HRMS_BASE}/reports/employees/export`,

  urlAttendance: (start, end) => {
    const p = new URLSearchParams(
      q({ start, end })
    ).toString();

    return `${http.defaults.baseURL}${HRMS_BASE}/reports/attendance/export${
      p ? `?${p}` : ""
    }`;
  },

  urlPayroll: (month) =>
    `${http.defaults.baseURL}${HRMS_BASE}/reports/payroll/export?month=${encodeURIComponent(month)}`,

  urlPF: (month) =>
    `${http.defaults.baseURL}${HRMS_BASE}/reports/pf/export?month=${encodeURIComponent(month)}`,

  urlESIC: (month) =>
    `${http.defaults.baseURL}${HRMS_BASE}/reports/esic/export?month=${encodeURIComponent(month)}`,
};

export default hrmsApi;